import http from "../http-common";
import { Project } from "../models/projectModel";

class ProjectDataService {
    async getAll() {
      return await http.post("/projects");
    }

    async createProject(project: { projectId: String, projectName: string, formId: String, formName: string, type:string, modalAttribute:any }) {
      const json = JSON.stringify(project);
      return await http.post("/projects/create", json);
    }

    async getProjectsByUserName(user: { userName : string }) {
      const json = JSON.stringify(user);
      return await http.post("/projects/user", json);
    }

    async getFormsByProject(project: {  userName : string, id : string }) {
      const json = JSON.stringify(project);
      return await http.post("/projects/forms", json);
    }

    async getProject(project: {  userName : string, projectId : string, formId: string }) {
      const json = JSON.stringify(project);
      return await http.post("/projects/id", json);
    }

    async updateProject(project: Project) {
      const json = JSON.stringify(project);
      return await http.post("/projects/update", json);
    }
  }

  export default new ProjectDataService();